<template>
  <div class="panel">
    <div
      class="panel-box"
      v-for="(item, index) in dataSouce"
      :key="'panel' + index"
      :style="{
        'flex-direction': item.direction === 'right' ? 'row-reverse' : '',
      }"
    >
      <div
        class="content"
        :style="{ 'padding-left': item.direction === 'right' ? '80px' : '' }"
      >
        <h3 class="title">{{ item.title }}</h3>
        <p class="subtitle">{{ item.subtitle }}</p>
        <ul class="item">
          <li v-for="(text, i) in item.list" :key="'list' + i">{{ text }}</li>
        </ul>
        <div class="iamge-min-phone">
          <img :src="item.image" :alt="item.title" />
        </div>
        <div class="big-button" @click="information(item.title)" data-agl-cvt="5">免费使用</div>
      </div>
      <div class="iamge">
        <img :src="item.image" :alt="item.title" />
      </div>
    </div>
  </div>
</template>

<script>
import { swTrackerClickReport } from '@/tracker.js'
export default {
  name: "SolutionPanel",
  props: {
    dataSouce: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      pathName: '',
    };
  },
  watch: {
    '$route.path' () {
      this.pathName = this.$route.name
    },
  },
  created () {
    this.pathName = this.$route.name
  },
  methods: {
    information(pathModule) {
      swTrackerClickReport('sw_pc_free_trial', pathModule, '解决方案-'+ this.pathName)
      this.$store.commit('doStayConsultation')
    },
  }
};
</script>

<style lang="scss" scoped>
.panel {
  width: 1200px;
  margin: 0 auto;
  padding-top: 50px;

  &-box {
    display: flex;
    margin-bottom: 120px;
    &:last-child {
      margin-bottom: 0px;
    }
    .content {
      width: 50%;
      text-align: left;
      padding-top: 40px;
      .title {
        font-size: 28px;
        font-weight: 600;
        color: #2d2e30;
         width:425px;
      }
      .subtitle {
        margin-top: 20px;
        font-size: 16px;
        font-weight: 500;
        color: #2d2e30;
         width:425px;
      }
      .item {
        margin-top: 30px;
        margin-bottom: 30px;
        width:425px;
        li {
          position: relative;
          margin: 8px 0 0 2px;
          color: #5a5c60;
        }
        li::after {
          content: "";
          position: absolute;
          left: -18px;
          top: 6px;
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          border: 2px solid #3777f6;
        }
      }
      .iamge-min-phone{
        display: none;
      }
    }
    .iamge {
      width: 50%;
      img {
        width: 100%;
      }
    }
  }

  .big-button {
    width: 106px;
    height: 40px;
    background: #3777f6;
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    cursor: pointer;
    text-align: center;
    margin-top: 40px;
    &:hover {
      background: #5f92f8;
    }
  }
}

// 移动端布局
@import "@/views/solution/min-solution";
</style>